import { useTranslation } from 'react-i18next'
import type { EvidenceStatus } from '../../types/evidence-numbers'

const STATUS_STYLES: Record<EvidenceStatus, string> = {
  registered: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300',
  collection_requested: 'bg-sky-100 text-sky-700 dark:bg-sky-950/50 dark:text-sky-400',
  collection_sent: 'bg-indigo-100 text-indigo-700 dark:bg-indigo-950/50 dark:text-indigo-400',
  data_returned: 'bg-amber-100 text-amber-700 dark:bg-amber-950/50 dark:text-amber-400',
  data_ingested: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-950/50 dark:text-emerald-400',
  data_exported: 'bg-violet-100 text-violet-700 dark:bg-violet-950/50 dark:text-violet-400',
  returned_to_client: 'bg-teal-100 text-teal-700 dark:bg-teal-950/50 dark:text-teal-400',
  destroyed: 'bg-rose-100 text-rose-700 dark:bg-rose-950/50 dark:text-rose-400',
}

interface EvidenceStatusBadgeProps {
  status: EvidenceStatus
  className?: string
}

export function EvidenceStatusBadge({
  status,
  className = '',
}: EvidenceStatusBadgeProps): React.ReactElement {
  const { t } = useTranslation('evidence')
  const style = STATUS_STYLES[status]

  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${style} ${className}`}
    >
      {t(`status.${status}`)}
    </span>
  )
}
